
import $ from 'jquery'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import html2canvas from 'html2canvas'
import api from '@/api/api'
export default {
name: 'screen_shot',
props: {
url: String,
fn_close: Function
},
data() {
return {
show_panel: false,
show_loading: true,
token: '',
pic_url: ''
}
},
methods: {
/**
* 初始化截图
*/
init(arr, liveId) {
this.show_panel = true
this.pic_url = ''
// 开始拼图
api.live.combinePicture(arr, liveId).then(res => {
if (res) {
this.pic_url = res.Result
this.show_loading = false
}
})
},

/**@augments
* 关闭截图页面
*/
close() {
this.show_panel = false
this.show_loading = true
this.fn_close()
}
},

components: {
Qrcode
}
}



// WEBPACK FOOTER //
// ./src/components/XShot/XShot.vue